import { createContext } from 'react';

const DisplaySettingsContext = createContext<
    DisplaySettingsContextType | undefined
>(undefined);

export default DisplaySettingsContext;
